import { useFormDataQuery } from '@/api/getters';
import {
  useFormMutation,
  useSubmitStagesMutation,
  useSubmitStepMutation,
} from '@/api/setters';
import { Steps } from '@/api/types';
import { formMutationDto } from '@/dto/formMutationDto';
import { useStepper } from '@/features/v2/lib/stepper';
import { SurveyComplementary } from '@/features/v2/vehicle-damage/complementaryInformation/survey/SurveyComplementary';
import { StepForm } from '@/features/v2/vehicle-damage/StepForm';
import { scrollToTop } from '@/helpers/scrollToTop';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const StepComplementary = () => {
  const { i18n } = useLingui();
  const { handleSubmit, watch } = useFormContext();
  const { data } = useFormDataQuery();
  const { step, innerObject, nextStep, setStepTag, isDeadEnd } = useStepper();

  const formMutation = useFormMutation();

  const submitStages = useSubmitStagesMutation({
    afterGetInvalidate: () => {
      nextStep();
      scrollToTop(600);
    },
  });

  const submitStep = useSubmitStepMutation();

  const onSubmit = async () => {
    await formMutation.mutateAsync({
      ...formMutationDto({
        form_data: watch(),
        stepper: {
          step: 5,
          innerStep: { ...innerObject, [step + 1]: 0 },
        },
      }),
    });
    data?.stage && (await submitStages.mutateAsync(data.stage));
    if (!isDeadEnd) {
      if (data?.step !== Steps.TRANSFER_DETAILS) {
        submitStep.mutateAsync(Steps.TRANSFER_DETAILS).then(() => {
          setStepTag(Steps.TRANSFER_DETAILS);
        });
      }
    }
  };

  return (
    <StepForm
      submitButton={{
        label: isDeadEnd
          ? i18n.t('Zakończ formularz')
          : i18n.t('Gotowe, przechodzę dalej'),
        isLoading: formMutation.isPending || submitStages.isPending,
        uniqTestId: 'step-complementary-submit',
      }}
      nextStageOnSubmit={false}
      isLastStep={true}
      onSubmit={handleSubmit(onSubmit)}
      nextButton={{
        uniqTestId: 'step-summary-complementary',
      }}
      prevButton={{
        uniqTestId: 'step-summary-complementary',
      }}
    >
      {step >= 4 && !!data?.offer.is_complementary && <SurveyComplementary />}
    </StepForm>
  );
};
